import { getHours, getMinutes, parseISO } from 'date-fns';
import { getTimezoneOffset, toZonedTime } from 'date-fns-tz';
import { getTimezone } from 'utils/shared/time/getTimezone';

interface TimeParams {
  timestamp: string; // Expecting format 'yyyy-MM-ddTHH:mm:ss'
  timezone?: string | null;
}

export function convertToMinutesAfterMidnight({ timestamp, timezone }: TimeParams) {
  const tz = getTimezone(timezone);

  // Convert UTC timestamp to user's local timezone
  const zonedDate = toZonedTime(parseISO(timestamp), tz);

  // Get hours and minutes in the local timezone
  const hours = getHours(zonedDate);
  const minutes = getMinutes(zonedDate);

  // Calculate minutes after midnight
  return hours * 60 + minutes;
}
